// extracted by mini-css-extract-plugin
module.exports = {"OrgFCListBase":"OrgRecommendFCList_OrgFCListBase__2q8Wc","OrgFCListTitle":"OrgRecommendFCList_OrgFCListTitle__30FGm","OrgFCListWrap":"OrgRecommendFCList_OrgFCListWrap__3n62X"};